export class Dispatcher
{
	constructor()
	{
		this._listeners = {};
	}

	on(type, cb)
	{
		if(!this._listeners.hasOwnProperty(type))
		{
			this._listeners[type] = [cb];
		}
		else
		{
			this._listeners[type].push(cb);
		}
	}

	off(type, cb)
	{
		if(this._listeners.hasOwnProperty(type))
		{
			let i = 0;
			let arr = this._listeners[type]
			let len = arr.length;
			for(; i < len; i++)
			{
				if(arr[i] === cb)
				{
					arr.splice(i, 1);
					return;
				}
			}
		}
	}

	dispatch(type, params)
	{
		if(this._listeners.hasOwnProperty(type))
		{
			let i = 0;
			let arr = this._listeners[type].slice(0);
			let len = arr.length;
			for(; i < len; i++)
			{	
				arr[i](params);
			}
		}
	}
}
